export const publishedPaidNewsletterNameQueryParam = 'publishedPaidNewsletterName';
